export const MetaNav = {
  name: '_MetaNav_',
  withChildren: true,
  inputs: [],
} as const;

export default MetaNav;
